<!-- メニュー -->
<app-menu></app-menu>

<!-- メイン -->
<div class="main">
  <!-- メインコンテンツ -->
  <div class="main-content" [class.platform-large-text]="getTextSize()">
    <!-- タイトル -->
    <div class="p-d-flex p-jc-center title">
      <div>
        <label>地方創生SDGs官民連携プラットフォーム</label><br />
        <label class="p-d-flex p-jc-center title-name">分科会</label>
      </div>
    </div>

    <div class="p-d-flex p-jc-center theme">
      {{ detailSubcommittee?.theme }}
    </div>
    <div class="p-d-flex p-jc-center organization_name">
      {{ detailSubcommittee?.organization_name }}
    </div>

    <!-- 編集ボタンエリア(主催会員の場合表示) -->
    <div class="p-d-flex p-jc-center"
      *ngIf="detailSubcommittee?.status.id != 3 && ((decisionPerspective(detailSubcommittee?.member_id) || decisionSecretariat() ) && currentYearFlag)">
      <!-- 編集ボタン -->
      <button pButton type="button" label="編集する" icon="pi pi-pencil" class="button1" (click)="moveE204()"></button>
    </div>

    <!-- 未参加の場合 -->
    <div class="p-d-flex p-jc-center join" *ngIf="('False' == isAlreadyJoin?.isalreadyjoin && !decisionPerspective(detailSubcommittee?.member_id) )
               && !decisionSecretariat()
               && currentYearFlag
               && checkAppliDate()
               ">
      <button pButton type="button" label="参加登録" class="button1" (click)="moveE401()"></button>
    </div>
    <!-- 参加済みの場合 -->
    <div class="p-d-flex p-jc-center join" *ngIf="('True' == isAlreadyJoin?.isalreadyjoin && !decisionPerspective(detailSubcommittee?.member_id) )
               && !decisionSecretariat() && currentYearFlag">
      <button pButton type="button" label="参加中" class="button1"
        [disabled]="'True' == isAlreadyJoin?.isalreadyjoin"></button>
    </div>

    <div class="margin-vertical"></div>
    <!-- 内閣府承認情報 -->
    <div class="approval-information" *ngIf="
        decisionPerspective(detailSubcommittee?.member_id) ||
        decisionSecretariat()
      ">
      <!-- 内閣府承認情報内容 -->
      <p-table [value]="[{}]" styleClass="information-Form">
        <ng-template pTemplate="body">
          <!-- 内閣府承認 -->
          <tr>
            <td class="item-name">運営事務局承認</td>
            <td class="item-information">
              <div [class.denial]="3 == 1">
                <div class="p-d-flex status">
                  <label class="p-as-center">
                    <!-- ステータス -->
                    <label class="status-name">{{
                      detailSubcommittee?.status.name
                      }}</label>
                    <!-- 承認日付 -->
                    <label>{{ detailSubcommittee?.status_datetime }}</label>
                  </label>

                  <div>
                    <!-- 前後確認 -->
                    <button pButton type="button" label="前後確認" class="button3 approval-button"
                      (click)="openDiffDialog('e202')" *ngIf="decisionSecretariat()"></button>
                    <!-- 承認可否 -->
                    <button pButton type="button" label="ステータス登録" class="button3 approval-button"
                      (click)="openSmallApprovalDialog()" *ngIf="decisionSecretariat()"></button>
                  </div>
                </div>
                <!-- 承認時コメント -->
                <div class="status-comment">
                  {{ detailSubcommittee?.status_comment }}
                </div>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <!-- サブタイトル -->
    <div *ngIf="memberEventDataList?.length != 0 && currentYearFlag">
      <div class="sub-title">
        <h2>分科会のイベント・お知らせ</h2>
      </div>
      <p-table #table [value]="memberEventDataList" styleClass="p-datatable-striped memberEventData"
        emptyMessage="データが存在しません" [autoLayout]="true" [scrollable]="true" scrollHeight="173px" responsiveLayout="scroll"
        selectionMode="single">
        <!-- ヘッダー -->
        <ng-template pTemplate="body" let-memberEventData>
          <!-- 対象のイベント・お知らせへの遷移処理を追加する -->
          <tr (click)="moveE102(memberEventData.member_event_id)">
            <!-- 掲載日 -->
            <td class="data-date">
              {{ memberEventData?.date }}
            </td>
            <!-- 掲載区分-->
            <td class="kbn">
              <!-- 区分が2の場合 -->
              <p-tag value="お知らせ" styleClass="notice-tag tag" *ngIf="2 == memberEventData?.event_kbn.id"></p-tag>
              <!-- 区分が4の場合 -->
              <p-tag value="イベント" styleClass="event-tag tag" *ngIf="4 == memberEventData?.event_kbn.id"></p-tag>
            </td>
            <!-- タイトル-->
            <td class="data-title">
              {{ memberEventData?.title }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <!-- サブタイトル -->
    <div class="sub-title">
      <h2>分科会の概要</h2>
    </div>
    <!-- 分科会 -->
    <p-table [value]="[{}]" styleClass="information-Form">
      <ng-template pTemplate="body">
        <!-- 分科会の目的 -->
        <tr>
          <td class="item-name">分科会の目的</td>
          <td class="item-information">{{ detailSubcommittee?.purpose }}</td>
        </tr>
        <!-- 解決したい課題 -->
        <tr>
          <td class="item-name">解決したい課題</td>
          <td class="item-information">{{ detailSubcommittee?.agenda }}</td>
        </tr>
        <!-- 活動概要 -->
        <tr>
          <td class="item-name">活動概要</td>
          <td class="item-information">{{ detailSubcommittee?.outline }}</td>
        </tr>
        <!-- 活動内容1 -->
        <tr *ngIf="decisionLoginState()">
          <td class="item-name">活動内容1</td>
          <td class="item-information">{{ detailSubcommittee?.note1 }}</td>
        </tr>
        <!-- 活動内容2 -->
        <tr *ngIf="decisionLoginState() && detailSubcommittee?.note2.length != 0">
          <td class="item-name">活動内容2</td>
          <td class="item-information">{{ detailSubcommittee?.note2 }}</td>
        </tr>
        <!-- 活動内容3 -->
        <tr *ngIf="decisionLoginState() && detailSubcommittee?.note3.length != 0">
          <td class="item-name">活動内容3</td>
          <td class="item-information">{{ detailSubcommittee?.note3 }}</td>
        </tr>
        <!-- 期待される成果 -->
        <tr>
          <td class="item-name">期待される成果</td>
          <td class="item-information">{{ detailSubcommittee?.outcome }}</td>
        </tr>
        <!-- 資金・物資計画 -->
        <tr *ngIf="decisionLoginState()">
          <td class="item-name">資金・物資計画</td>
          <td class="item-information">
            {{ detailSubcommittee?.funding_plan }}
          </td>
        </tr>
        <!-- 主に関連するゴール -->
        <tr>
          <td class="item-name">主に関連するゴール</td>
          <td class="item-information target">
            <div class="image" *ngFor="let sdgs_goal of detailSubcommittee?.sdgs_goal">
              <img [src]="sdgs_goal.sp_ext" alt="image" />
            </div>
          </td>
        </tr>
        <!-- 計画書概要 -->
        <tr>
          <td class="item-name">計画書概要</td>
          <td class="item-information">
            <div class="p-d-flex">
              <!-- ファイル名-->
              <div class="p-as-center">
                {{ detailSubcommittee?.image.name }}
              </div>
              <!-- ファイルDL-->
              <button
                pButton
                label="ダウンロード"
                [value]="detailSubcommittee?.image.file_path"
                onClick="window.open(this.value, '_blank')"
                class="button1 dlButton"
                [disabled]="!detailSubcommittee?.image.file_path"
              ></button>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>

    <div *ngIf="decisionLoginState()">
      <div class="margin-vertical"></div>

      <!-- サブタイトル -->
      <div class="sub-title">
        <h2>参加メンバーへの期待</h2>
      </div>
      <!-- 参加メンバー -->
      <p-table [value]="[{}]" styleClass="information-Form">
        <ng-template pTemplate="body">
          <!-- 参加してほしいメンバー -->
          <tr>
            <td class="item-name">参加してほしいメンバー</td>
            <td class="item-information">
              {{ detailSubcommittee?.members_who_want }}
            </td>
          </tr>
          <!-- 想定しているメンバー数 -->
          <tr>
            <td class="item-name">想定しているメンバー数</td>
            <td class="item-information">
              {{ detailSubcommittee?.members_count }}
            </td>
          </tr>
          <!-- メンバーへの期待 -->
          <tr>
            <td class="item-name">メンバーへの期待</td>
            <td class="item-information">
              {{ detailSubcommittee?.members_expectation }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <div *ngIf="decisionLoginState()">
      <div class="margin-vertical"></div>

      <!-- サブタイトル -->
      <div class="sub-title">
        <h2>実施スケジュール</h2>
      </div>
      <!-- 実施スケジュール -->
      <p-table [value]="[{}]" styleClass="information-Form">
        <ng-template pTemplate="body">
          <!-- 実施スケジュール -->
          <tr>
            <td class="item-name">実施スケジュール</td>
            <td class="item-information">{{ detailSubcommittee?.schedule }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <div *ngIf="decisionLoginState() && detailSubcommittee?.note.length != 0">
      <div class="margin-vertical"></div>

      <!-- サブタイトル -->
      <div class="sub-title">
        <h2>その他特記事項</h2>
      </div>
      <!-- その他特記事項 -->
      <p-table [value]="[{}]" styleClass="information-Form">
        <ng-template pTemplate="body">
          <!-- その他特記事項 -->
          <tr>
            <td class="item-name">その他特記事項</td>
            <td class="item-information">{{ detailSubcommittee?.note }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <!-- 主催、窓口 -->
    <div *ngIf="decisionLoginState()">
      <div class="margin-vertical"></div>

      <!-- サブタイトル -->
      <div class="sub-title">
        <h2>主催・窓口</h2>
      </div>
      <!-- 主催、窓口 -->
      <p-table [value]="[{}]" styleClass="information-Form">
        <ng-template pTemplate="body">
          <!-- 主催（団体名称） -->
          <tr>
            <td class="item-name">主催（団体名称）</td>
            <td class="item-information">
              {{ detailSubcommittee?.organizer_group_name }}
            </td>
          </tr>
          <!-- 主催（部署名） -->
          <tr>
            <td class="item-name">主催（部署名）</td>
            <td class="item-information">
              {{ detailSubcommittee?.organizer_divition_name }}
            </td>
          </tr>
          <!-- 主催（担当者名） -->
          <tr>
            <td class="item-name">主催（担当者名）</td>
            <td class="item-information">
              {{ detailSubcommittee?.organizer_person_name }}
            </td>
          </tr>
          <!-- 主催（電話番号） -->
          <tr *ngIf="detailSubcommittee?.organizer_tel.length != 0">
            <td class="item-name">主催（電話番号）</td>
            <td class="item-information">
              {{ detailSubcommittee?.organizer_tel }}
            </td>
          </tr>
          <!-- 主催（eメールアドレス） -->
          <tr>
            <td class="item-name">主催（eメールアドレス）</td>
            <td class="item-information">
              {{ detailSubcommittee?.organizer_email }}
            </td>
          </tr>
          <!-- 窓口（団体名称） -->
          <tr *ngIf="detailSubcommittee?.reception_group_name.length != 0">
            <td class="item-name">窓口（団体名称）</td>
            <td class="item-information">
              {{ detailSubcommittee?.reception_group_name }}
            </td>
          </tr>
          <!-- 窓口（部署名） -->
          <tr *ngIf="detailSubcommittee?.reception_divition_name.length != 0">
            <td class="item-name">窓口（部署名）</td>
            <td class="item-information">
              {{ detailSubcommittee?.reception_divition_name }}
            </td>
          </tr>
          <!-- 窓口（担当者名） -->
          <tr *ngIf="detailSubcommittee?.reception_person_name.length != 0">
            <td class="item-name">窓口（担当者名）</td>
            <td class="item-information">
              {{ detailSubcommittee?.reception_person_name }}
            </td>
          </tr>
          <!-- 窓口（電話番号） -->
          <tr *ngIf="detailSubcommittee?.reception_tel.length != 0">
            <td class="item-name">窓口（電話番号）</td>
            <td class="item-information">
              {{ detailSubcommittee?.reception_tel }}
            </td>
          </tr>
          <!-- 窓口（eメールアドレス） -->
          <tr *ngIf="detailSubcommittee?.reception_email.length != 0">
            <td class="item-name">窓口（eメールアドレス）</td>
            <td class="item-information">
              {{ detailSubcommittee?.reception_email }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <!-- 未参加の場合 -->
    <div class="p-d-flex p-jc-center join" *ngIf="('False' == isAlreadyJoin?.isalreadyjoin && !decisionPerspective(detailSubcommittee?.member_id) )
                && !decisionSecretariat()
                && currentYearFlag
                && checkAppliDate()
                ">
      <button pButton type="button" label="参加登録" class="button1" (click)="moveE401()"></button>
    </div>

    <!-- 参加メンバー一覧 -->
    <!-- 本項目は主催ユーザのみ表示 -->
    <div *ngIf="currentYearFlag && ((decisionLoginState() && isOrganizerContactFlag ) || decisionSecretariat())">
      <div class="margin-vertical"></div>

      <!-- サブタイトル -->
      <div class="sub-title">
        <h2>参加メンバー一覧</h2>
      </div>

      <div class="p-d-flex p-jc-center p-jc-between">
        <div class="count">
          <label>
            {{ memberCount }} 会員 ／ {{ userCount }} ユーザー
          </label>
          <!-- ファイルDL-->
          <button pButton label="CSVダウンロード" (click)="exportCSV()" class="button1 csvDlButton"></button>
        </div>
        <div>
          ※メンバーの初期表示は、参加登録順に表示されております。
        </div>
      </div>
      <!-- 参加メンバー一覧 -->
      <p-table #table [value]="subcommitteeMemberList" [paginator]="true" [rows]="10" [showCurrentPageReport]="true"
        currentPageReportTemplate="{first}~{last}件表示({totalRecords}件中)" [rowsPerPageOptions]="[10, 50, 100, 500, 1000]"
        emptyMessage="データが存在しません" selectionMode="single" styleClass="list-area">
        <!-- ヘッダー -->
        <ng-template pTemplate="header">
          <!-- 検索結果数 -->
          <tr>
              <th class="data-name" pSortableColumn="user_id.name">氏名<p-sortIcon field="name"></p-sortIcon></th>
              <th class="data-organization_name" pSortableColumn="organization_name">団体名称<p-sortIcon field="organization_name"></p-sortIcon></th>
              <th class="data-want" pSortableColumn="want">本プラットフォームにおける活動で実現したいこと<p-sortIcon field="status"></p-sortIcon></th>
              <th class="data-member_kbn" pSortableColumn="member_kbn.name">メンバー区分<p-sortIcon field="member_kbn"></p-sortIcon></th>
              <th class="data-kbn"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-subcommitteeMember>
          <tr>
            <!-- 氏名 -->
            <td class="data-name">
              {{ subcommitteeMember?.user_id.name }}
            </td>
            <!-- 団体名称-->
            <td class="data-organization_name">
              {{ subcommitteeMember?.organization_name }}
            </td>
            <td class="data-want">
              {{ subcommitteeMember?.want }}
            </td>
            <!-- メンバー区分-->
            <td class="data-member_kbn">
              {{ subcommitteeMember?.member_kbn.name }}
              <!-- 主催・窓口 -->
            </td>
            <!-- 区分変更-->
            <td class="data-kbn">
              <button pButton type="button" label="区分変更" class="button1"
                (click)="openCategoryChangeDialog(subcommitteeMember?.member_kbn.id,subcommitteeMember?.user_id.id)"
                [disabled]="'False' == subcommitteeMember?.ischange"></button>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    <!-- 参加済みの場合 -->
    <div class="p-d-flex p-jc-center join"
        *ngIf="('True' == isAlreadyJoin?.isalreadyjoin && !decisionPerspective(detailSubcommittee?.member_id) )
              && !isOrganizerContactFlag
              && !decisionSecretariat()
              && currentYearFlag">
      <button pButton type="button" label="退会" class="button2" (click)="openWithdrawalDialog()"></button>
    </div>

    <!-- 共通部品_承認時ダイアログ -->
    <app-approval-dialog (returnApproval)="getDetailSubcommittee()"></app-approval-dialog>

    <!-- 共通部品_差分比較ダイアログ -->
    <app-diff-table></app-diff-table>

    <!-- 共通部品_区分変更/退会ダイアログ -->
    <app-subcommittee-dialog (returnChange)="getDetailSubcommittee()"></app-subcommittee-dialog>

  </div>

  <!-- フッダー -->
  <footer>
    <app-footer></app-footer>
  </footer>